import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import updateRaToUser from 'API/Users/updateRaToUser';

const useConvertRaToUser = ({ onClose, platformUserId, userType }) => {
    return useMutation({
        mutationFn: async () => {
            try {
                const res = await updateRaToUser({ platformUserId, userType });
                if (res.data || res.status === 200) {
                    toast.success('Converted RA to user successfully!');
                    onClose();
                }
                return res.data;
            } catch (err) {
                const errorMessage = `Failed to convert RA to user: ${err?.response?.data?.message || 'Please try again later'}`;
                toast.error(errorMessage);
                throw new Error(err);
            }
        },
    });
};

export default useConvertRaToUser;
